<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error && _vm.error.length
    ? _c("small", { staticClass: "text-danger" }, [_vm._v(_vm._s(_vm.error))])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/Errors.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

//
//
//

export default ({
  render,
  staticRenderFns,
  props: {
    error: {
      type: String,
      default: ""
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/Errors.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

